import { ChangeEvent, useState } from "react";

import { Toggle } from "@vimeo/iris/components";
import { Text } from "@vimeo/iris/typography";

import { Spinner } from "@salesforce/design-system-react";

import { Video } from "vimeo";
import { updateEmbedSettings } from "./embedSettings";

import "./common.scoped.scss";

interface Props {
    video: Video;
    onUpdate: (video: Video) => void;
    onError: (msg: string) => void;
}

export function YourDetails(props: Props) {
    const { video, onUpdate, onError } = props;
    const [loading, setLoading] = useState(false);

    async function onSettingsChange(e: ChangeEvent, propertyName: string) {
        setLoading(true);

        try {
            const embedSettings: any = {};
            const value = (e.target as HTMLInputElement).checked
                ? "show"
                : "hide";
            embedSettings[propertyName] = value;
            const updatedVideo = await updateEmbedSettings(video, {
                title: {
                    ...embedSettings,
                },
            });

            onUpdate(updatedVideo);
        } catch (err) {
            onError("Failed to save changes. Please try again later.");
        }
        setLoading(false);
    }

    async function onLetUsersDecideToggle(e: ChangeEvent) {
        setLoading(true);
        try {
            const value = (e.target as HTMLInputElement).checked
                ? "user"
                : "hide";
            const updatedVideo = await updateEmbedSettings(video, {
                title: {
                    name: value,
                    portrait: value,
                    owner: value,
                },
            });

            onUpdate(updatedVideo);
        } catch (err) {
            onError("Failed to save changes. Please try again later.");
        }
        setLoading(false);
    }

    return (
        <>
            {loading && <Spinner />}
            <Text size={300} style={{ fontWeight: 500 }}>
                Your details
            </Text>
            <div className="toggles-container">
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Profile picture"
                            checked={video.embed.title.portrait === "show"}
                            disabled={video.embed.title.portrait === "user"}
                            onChange={(e) => onSettingsChange(e, "portrait")}
                        />
                    </div>
                </div>
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Title"
                            checked={video.embed.title.name === "show"}
                            disabled={video.embed.title.name === "user"}
                            onChange={(e) => onSettingsChange(e, "name")}
                        />
                    </div>
                </div>
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Byline"
                            checked={video.embed.title.owner === "show"}
                            disabled={video.embed.title.owner === "user"}
                            onChange={(e) => onSettingsChange(e, "owner")}
                        />
                    </div>
                </div>
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Let users decide"
                            // Just check if any one of the title settings is set to user,
                            // then assume all of them are set to "Let users decide".
                            checked={video.embed.title.portrait === "user"}
                            onChange={onLetUsersDecideToggle}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
